// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"642":"universal-cropper","778":"company-settings"}[chunkId] || chunkId) + ".css";
};